import EventsWidget from './EventsWidget';

export default EventsWidget;
